import { Stack, Typography } from '@ace-clublabs/shared-component-library';
import { PropsWithChildren, ReactNode } from 'react';

export interface MembershipOverviewItemProps extends PropsWithChildren {
  heading: ReactNode;
  content?: ReactNode;
  label?: string;
}

export const MembershipOverviewItem = (props: MembershipOverviewItemProps): JSX.Element => {
  const { heading, content, label, children } = props;
  return (
    <Stack className="membership-overview-item">
      <Typography className={label} variant="b1Medium">
        {heading}
      </Typography>
      {content ? (
        <div data-di-mask="true" className="qm-mask">
          {content}
        </div>
      ) : (
        <></>
      )}
      {children}
    </Stack>
  );
};
